// import { Flex, message, Modal, Spin } from 'antd'
// import React, { useEffect, useState } from 'react'
// import { CiCirclePlus } from 'react-icons/ci';
// import { base64ToFile, encodeBase64File } from '../../../../../utils/encodeBase64';
// import { EyeOutlined, UploadOutlined } from "@ant-design/icons";
// import AddInsuranceDetails from './addInsuranceDetails';
// import ProgInsuranceCCTable from './progInsuranceCCTable';
// import nodatafound from "../../../../../Assets/Images/Svg/nodatafound.svg";
// import AddChronicCondition from './addNewRpmChronic';
// import { useDispatch, useSelector } from 'react-redux';
// import { convertUTCDate } from '../../../../../utils/convertionFunc';
// import { handleSetPatientRegistrationPayload } from '../../../../../Redux/actions/patientActions';
// import deleteHoverIcon from "../../../../../Assets/Images/hoverdelete.svg";


// function ProgramInsurance({ currPageView, handleCancel, handleNext, handlePrevious }) {
//     const [consentOne, setConsentOne] = useState(null);
//     const [consentTwo, setConsentTwo] = useState(null);
//     const [consentThree, setConsentThree] = useState(null);
//     const [ConsentFour, setConsentFour] = useState(null);
//     const [viewDoc, setViewDoc] = useState("");
//     const [pdfVisible, setpdfVisible] = useState(false);
//     const [isLoading, setIsLoading] = useState(false);
//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const [currLocalMappedChronics, setCurrLocalMappedChronics] = useState([]);
//     const [currUploadedConsents, setCurrUploadedConsents] = useState([]);
//     const { registrationPayload, selectedEditPatient } = useSelector((state) => state.patients);
//     const dispatch = useDispatch();
//     const loggedUserObj = sessionStorage.getItem('login_result');
//     const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

//     useEffect(() => {
//         if (selectedEditPatient?.patientChronicConditionsList) {
//             setCurrLocalMappedChronics(selectedEditPatient?.patientChronicConditionsList);
//         }

//         if (selectedEditPatient?.patientRegConsentDtlList && selectedEditPatient?.patientRegConsentDtlList.length > 0) {
//             selectedEditPatient.patientRegConsentDtlList.forEach(item => {
//                 const { consentCode, esignName } = item;
//                 // const fileName = `Consent_${consentCode}.pdf`;
//                 // const fileBlob = base64ToFile(esign, fileName, esignType);
//                 console.log(esignName, ' esign')
//                 if (item.esignName) {
//                     switch (consentCode) {
//                         case 'PROGRAM':
//                             setConsentOne(process.env.REACT_APP_IMAGE_URL + esignName);
//                             break;
//                         case 'PATIENT_DATA':
//                             setConsentTwo(process.env.REACT_APP_IMAGE_URL + esignName);
//                             break;
//                         case 'DEVICE_RESP':
//                             setConsentThree(process.env.REACT_APP_IMAGE_URL + esignName);
//                             break;
//                         case 'PHYSICIAN_ORDER':
//                             setConsentFour(process.env.REACT_APP_IMAGE_URL + esignName);
//                             break;
//                         default:
//                             break;
//                     }
//                 }
//             });
//         }
//     }, [selectedEditPatient]);


//     const changeHandler = async (file, e) => {
//         if (file.type !== "application/pdf") {
//             message.error("Please upload only PDF files");
//             return;
//         }

//         // const max_size = 1 * 1024 * 1024; // for 1 mb
//         // const max_size = 5 * 1024 * 1024; // for 5 mb
//         const max_size = 10 * 1024 * 1024; // for 10 mb 

//         if (file && file.size > max_size) {
//             message.error("Pdf size should be less than or equal to 10 mb !!");
//             return;
//         }

//         const base64Encoded = await encodeBase64File(file);

//         const payload = {
//             account_Id: loggedUser?.user?.account_Id,
//             clinic_Id: loggedUser?.user?.clinic_Id,
//             consentCode: e,
//             consentName: "",
//             createdBy: loggedUser?.user?.userId,
//             createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
//             esign: base64Encoded,
//             esignType: file.type.split('/')[1],
//             modifiedBy: loggedUser?.user?.userId,
//             modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
//             otpConsent: "Y",
//             status: 1,
//         };

//         if (selectedEditPatient) {
//             payload.patientId = selectedEditPatient.patientId;
//         }

//         switch (e) {
//             case 'PROGRAM':
//                 payload.consentName = "OnProgram";
//                 setConsentOne(file);
//                 break;
//             case 'PATIENT_DATA':
//                 payload.consentName = "ToSharePatientData";
//                 setConsentTwo(file);
//                 break;
//             case 'DEVICE_RESP':
//                 payload.consentName = "OnDeviceResponsibility";
//                 setConsentThree(file);
//                 break;
//             case 'PHYSICIAN_ORDER':
//                 payload.consentName = "Physician Order";
//                 setConsentFour(file);
//                 break;
//             default:
//                 break;
//         }

//         const currItemsInConsent = [...registrationPayload?.patientRegConsentDtlList] || [];
//         const updatedItems = currItemsInConsent.filter(item => item.consentCode !== e);
//         updatedItems.push(payload);

//         const pdfPayload = {
//             ...registrationPayload,
//             patientRegConsentDtlList: updatedItems
//         };

//         dispatch(handleSetPatientRegistrationPayload(pdfPayload));
//     };


//     const showPdf = (e) => {
//         let file;
//         if (e === 'PROGRAM') file = consentOne;
//         if (e === 'PATIENT_DATA') file = consentTwo;
//         if (e === 'DEVICE_RESP') file = consentThree;
//         if (e === 'PHYSICIAN_ORDER') file = ConsentFour;

//         if (!file) return;

//         if (typeof file === 'string') {
//             if (file.toLowerCase().endsWith('.pdf')) {
//                 setViewDoc(file);
//                 setpdfVisible(true);
//             }
//         }
//         else if (file instanceof File && file.type === 'application/pdf') {
//             const fileURL = URL.createObjectURL(file);
//             setViewDoc(fileURL);
//             setpdfVisible(true);
//         }
//     };


//     const handleModalOpen = () => {
//         setIsModalOpen(true);
//     };

//     const handleModalClose = () => {
//         setIsModalOpen(false);
//     };

//     const handlSetLocalMappedChronics = (mappingObj) => {
//         setCurrLocalMappedChronics((prevState) => [...prevState, mappingObj]);
//     }

//     const handlePdfViewClose = () => {
//         setpdfVisible(false);
//     }

//     const handleDelete = (e) => {
//         if (e === 'PROGRAM') setConsentOne(null);
//         if (e === 'PATIENT_DATA') setConsentTwo(null);
//         if (e === 'DEVICE_RESP') setConsentThree(null);
//         if (e === 'PHYSICIAN_ORDER') setConsentFour(null);

//         const currItemsInConsent = [...registrationPayload?.patientRegConsentDtlList] || [];

//         const currItemsAfterDeletion = currItemsInConsent.filter((item) => item.consentCode !== e);

//         const pdfPayload = {
//             ...registrationPayload,
//             patientRegConsentDtlList: currItemsAfterDeletion
//         };

//         dispatch(handleSetPatientRegistrationPayload(pdfPayload));
//     }

//     // return (
//     //     <div>
//     //         <div className="w-full">
//     //             <div className="flex justify-between space-x-4 m-2 mb-5">
//     //                 <div>
//     //                     <h3 className="font-bold text-base">Chronic Conditions</h3>
//     //                 </div>
//     //                 <div>
//     //                     <button
//     //                         onClick={handleModalOpen}
//     //                         className="w-24 h-9 px-2 flex bg-[#F1FFF9] items-center gap-1 border border-[#3B98B9] rounded-md"
//     //                     >
//     //                         <CiCirclePlus className=" text-[#189FAA]" />
//     //                         <span>Add New</span>
//     //                     </button>
//     //                 </div>
//     //             </div>
//     //         </div>
//     //         <>
//     //             <div className={`${isLoading === false && currLocalMappedChronics?.length === 0 ? 'w-full flex justify-center items-center' : 'overflow-y-scroll h-[23rem] scrollWidth'}`}>
//     //                 {isLoading && currLocalMappedChronics?.length === 0 ? (
//     //                     <div className="flex items-center justify-center mt-[10%]">
//     //                         <Flex align="center" gap="middle">
//     //                             <Spin size="large" tip="Loading" />
//     //                         </Flex>
//     //                     </div>
//     //                 ) :
//     //                     currLocalMappedChronics?.length === 0 ?
//     //                         (<div className="flex flex-col items-center justify-center">
//     //                             <img src={nodatafound} alt="nodatafound" className="h-min w-min" />
//     //                             <p className="font-medium text-xl">No data found!!</p>
//     //                         </div>)
//     //                         :
//     //                         (
//     //                             <div>
//     //                                 <ProgInsuranceCCTable
//     //                                     data={currLocalMappedChronics}
//     //                                     totalCount={currLocalMappedChronics?.length}
//     //                                 />
//     //                             </div>
//     //                         )}

//     //             </div>
//     //         </>


//     //         <div>
//     //             <h3 className="font-bold text-base my-3">Insurance</h3>
//     //             <AddInsuranceDetails
//     //                 currPageView={currPageView}
//     //                 handleCancel={handleCancel}
//     //                 handleNext={handleNext}
//     //                 handlePrevious={handlePrevious}
//     //                 currLocalMappedChronics={currLocalMappedChronics}
//     //             >
//     //                 <div>
//     //                     <h3 className="font-bold text-base my-3">Consent Form</h3>
//     //                     <div>
//     //                         <div>
//     //                             <div className="my-3 items-center" >
//     //                                 <div>
//     //                                     <label for="code">
//     //                                         Physician Order <span style={{ color: "#FF000F" }}>*</span>
//     //                                     </label>
//     //                                 </div>
//     //                                 <div>
//     //                                     <div class="flex items-center">
//     //                                         <label className="cursor-pointer viewbtn">
//     //                                             <input
//     //                                                 type="file"
//     //                                                 onChange={(e) => {
//     //                                                     changeHandler(e.target.files[0], 'PHYSICIAN_ORDER');
//     //                                                 }}
//     //                                                 id="consentForm2"
//     //                                                 name="consentForm2"
//     //                                                 // accept="application/pdf"
//     //                                                 class="w-100"
//     //                                                 className="hidden"
//     //                                             />
//     //                                             {/* <img src={Plus} alt="camera" className="w-5 h-5" /> */}
//     //                                             <span className=" text-brand-textWhite text-lg"><UploadOutlined className="text-brand-primaryColor font-bold" /></span>
//     //                                         </label>
//     //                                         {(ConsentFour) &&
//     //                                             (<div className='flex items-center gap-1'>
//     //                                                 <button
//     //                                                     className="px-1 text-lg ml-3"
//     //                                                     onClick={() => {
//     //                                                         showPdf('PHYSICIAN_ORDER');
//     //                                                     }}
//     //                                                 >
//     //                                                     <EyeOutlined className="cursor-pointer text-base" />
//     //                                                 </button>
//     //                                                 <button
//     //                                                     onClick={() => handleDelete('PHYSICIAN_ORDER')}
//     //                                                 >
//     //                                                     <img
//     //                                                         className="cursor-pointer w-3.5 h-3.5"
//     //                                                         src={deleteHoverIcon}
//     //                                                         alt="delete"
//     //                                                     />
//     //                                                 </button>
//     //                                             </div>)
//     //                                         }
//     //                                     </div>
//     //                                 </div>
//     //                             </div>
//     //                         </div>
//     //                         <div>
//     //                             <div className="my-3">
//     //                                 <div span={8}>
//     //                                     <label for="code">
//     //                                         On Device Responsibility{" "}
//     //                                         <span style={{ color: "#FF000F" }}>*</span>
//     //                                     </label>
//     //                                 </div>
//     //                                 <div>
//     //                                     <div class="flex items-center">
//     //                                         <label className="cursor-pointer viewbtn">
//     //                                             <input
//     //                                                 type="file"
//     //                                                 onChange={(e) => {
//     //                                                     changeHandler(e.target.files[0], 'DEVICE_RESP');
//     //                                                 }}
//     //                                                 id="consentForm2"
//     //                                                 name="consentForm2"
//     //                                                 accept="application/pdf"
//     //                                                 class="w-100"
//     //                                                 className="hidden"
//     //                                             />
//     //                                             {/* <img src={Plus} alt="camera" className="w-5 h-5" /> */}
//     //                                             <span className="text-brand-textWhite text-lg"><UploadOutlined className="text-brand-primaryColor" /></span>
//     //                                         </label>
//     //                                         {(consentThree) &&
//     //                                             (<div className='flex items-center gap-1'>
//     //                                                 <button
//     //                                                     className="px-1 text-lg ml-3"
//     //                                                     onClick={() => {
//     //                                                         showPdf('DEVICE_RESP');
//     //                                                     }}
//     //                                                 >
//     //                                                     <EyeOutlined className="cursor-pointer text-base" />
//     //                                                 </button>
//     //                                                 <button
//     //                                                     onClick={() => handleDelete('DEVICE_RESP')}
//     //                                                 >
//     //                                                     <img
//     //                                                         className="cursor-pointer w-3.5 h-3.5"
//     //                                                         src={deleteHoverIcon}
//     //                                                         alt="delete"
//     //                                                     />
//     //                                                 </button>
//     //                                             </div>)
//     //                                         }
//     //                                     </div>
//     //                                 </div>
//     //                             </div>
//     //                         </div>
//     //                         <div>
//     //                             <div className="my-3">
//     //                                 <div>
//     //                                     <label for="code">
//     //                                         To Share Patient Data <span style={{ color: "#FF000F" }}>*</span>
//     //                                     </label>
//     //                                 </div>
//     //                                 <div span={12}>
//     //                                     <div class="flex items-center">
//     //                                         <label className="cursor-pointer viewbtn">
//     //                                             <input
//     //                                                 type="file"
//     //                                                 onChange={(e) => {
//     //                                                     changeHandler(e.target.files[0], 'PATIENT_DATA');
//     //                                                 }}
//     //                                                 id="consentForm2"
//     //                                                 name="consentForm2"
//     //                                                 accept="application/pdf"
//     //                                                 class="w-100"
//     //                                                 className="hidden"
//     //                                             />
//     //                                             {/* <img src={Plus} alt="camera" className="w-5 h-5" /> */}
//     //                                             <span className="text-brand-textWhite text-lg"><UploadOutlined className="text-brand-primaryColor" /></span>
//     //                                         </label>
//     //                                         {(consentTwo) &&
//     //                                             (
//     //                                                 <div className='flex items-center gap-1'>
//     //                                                     <button
//     //                                                         type="button"
//     //                                                         className="px-1 text-lg ml-3"
//     //                                                         onClick={() => {
//     //                                                             showPdf('PATIENT_DATA');
//     //                                                         }}
//     //                                                     >
//     //                                                         <EyeOutlined className="cursor-pointer text-base" />
//     //                                                     </button>
//     //                                                     <button
//     //                                                         onClick={() => handleDelete('PATIENT_DATA')}
//     //                                                     >
//     //                                                         <img
//     //                                                             className="cursor-pointer w-3.5 h-3.5"
//     //                                                             src={deleteHoverIcon}
//     //                                                             alt="delete"
//     //                                                         />
//     //                                                     </button>
//     //                                                 </div>
//     //                                             )
//     //                                         }
//     //                                     </div>
//     //                                 </div>
//     //                             </div>
//     //                         </div>
//     //                         <div>
//     //                             <div className="my-3">
//     //                                 <div>
//     //                                     <label for="code">
//     //                                         On Program <span style={{ color: "#FF000F" }}>*</span>
//     //                                     </label>
//     //                                 </div>
//     //                                 <div span={12}>
//     //                                     <div class="flex items-center">
//     //                                         <label className="cursor-pointer viewbtn">
//     //                                             <input
//     //                                                 type="file"
//     //                                                 onChange={(e) => {
//     //                                                     changeHandler(e.target.files[0], 'PROGRAM');
//     //                                                 }}
//     //                                                 id="consentForm2"
//     //                                                 name="consentForm2"
//     //                                                 accept="application/pdf"
//     //                                                 class="w-100"
//     //                                                 className="hidden"
//     //                                             />
//     //                                             {/* <img src={Plus} alt="camera" className="w-5 h-5" /> */}
//     //                                             <span className="text-brand-textWhite text-lg"><UploadOutlined className="text-brand-primaryColor" /></span>
//     //                                         </label>
//     //                                         {(consentOne) &&
//     //                                             (
//     //                                                 <div className='flex items-center gap-1'>
//     //                                                     <button
//     //                                                         className="px-1 text-lg ml-3"
//     //                                                         onClick={() => {
//     //                                                             showPdf('PROGRAM');
//     //                                                         }}
//     //                                                     >
//     //                                                         <EyeOutlined className="cursor-pointer text-base" />
//     //                                                     </button>
//     //                                                     <button
//     //                                                         onClick={() => handleDelete('PROGRAM')}
//     //                                                     >
//     //                                                         <img
//     //                                                             className="cursor-pointer w-3.5 h-3.5"
//     //                                                             src={deleteHoverIcon}
//     //                                                             alt="delete"
//     //                                                         />
//     //                                                     </button>
//     //                                                 </div>
//     //                                             )
//     //                                         }
//     //                                     </div>
//     //                                 </div>
//     //                             </div>
//     //                         </div>
//     //                     </div>
//     //                 </div>
//     //             </AddInsuranceDetails>
//     //         </div>


//     //         <Modal
//     //             title={<span className="font-bold text-base">Add Chronic Condition</span>}
//     //             open={isModalOpen}
//     //             onCancel={handleModalClose}
//     //             footer={[]}
//     //             destroyOnClose
//     //         >
//     //             <AddChronicCondition handleModalClose={handleModalClose} handlSetLocalMappedChronics={handlSetLocalMappedChronics} />
//     //         </Modal>

//     //         <Modal
//     //             title="View"
//     //             open={pdfVisible}
//     //             centered={true}
//     //             footer={[]}
//     //             onCancel={handlePdfViewClose}
//     //             width={600}
//     //             destroyOnClose
//     //         >
//     //             <embed
//     //                 src={viewDoc}
//     //                 width="100%"
//     //                 type="application/pdf"
//     //                 height="500px"
//     //             />
//     //         </Modal>
//     //     </div>
//     // )
//     return (
//         <div>
//             <div className="w-full">
//                 <div className="flex justify-between space-x-4 m-2 mb-5">
//                     <div>
//                         <h3 className="font-bold text-base">Chronic Conditions</h3>
//                     </div>
//                     <div>
//                         <button
//                             onClick={handleModalOpen}
//                             className="w-28 h-9 px-2 flex bg-[#F1FFF9] items-center gap-2 border border-[#3B98B9] rounded-md"
//                         >
//                             <span className="w-5 h-5">
//                                 <CiCirclePlus className="w-full text-[#189FAA] h-full" />
//                             </span>
//                             <span className="">Add New</span>
//                         </button>
//                     </div>
//                 </div>
//             </div>
//             <>
//                 <div
//                     className={`${isLoading === false && currLocalMappedChronics?.length === 0
//                             ? "w-full flex justify-center items-center"
//                             : "overflow-y-scroll scrollWidth"
//                         }`}
//                 >
//                     {isLoading && currLocalMappedChronics?.length === 0 ? (
//                         <div className="flex items-center justify-center mt-[10%]">
//                             <Flex align="center" gap="middle">
//                                 <Spin size="large" tip="Loading" />
//                             </Flex>
//                         </div>
//                     ) : currLocalMappedChronics?.length === 0 ? (
//                         <div className="flex flex-col items-center justify-center">
//                             <img
//                                 src={nodatafound}
//                                 alt="nodatafound"
//                                 className="h-min w-min"
//                             />
//                             <p className="font-medium text-xl">No data found!!</p>
//                         </div>
//                     ) : (
//                         <div>
//                             <ProgInsuranceCCTable
//                                 data={currLocalMappedChronics}
//                                 totalCount={currLocalMappedChronics?.length}
//                             />
//                         </div>
//                     )}
//                 </div>
//             </>

//             <div>
//                 <h3 className="font-bold text-base my-3">Insurance</h3>
//                 <AddInsuranceDetails
//                     currPageView={currPageView}
//                     handleCancel={handleCancel}
//                     handleNext={handleNext}
//                     handlePrevious={handlePrevious}
//                     currLocalMappedChronics={currLocalMappedChronics}
//                 >
//                     <div>
//                         <h3 className="font-bold text-base my-3">Consent Form</h3>
//                         <h4 className="font-bold text-base my-3">Attachment Details</h4>
//                         <div>
//                             File Supported:{" "}
//                             <span className="text-blue-500"> PDF - Up to 10MB</span>
//                         </div>

//                         <div className="grid md:grid-cols-4 grid-cols-2 gap-1">
//                             <div className="my-3 items-center bg-[#F4FEFF] rounded-md p-2 border">
//                                 <label>
//                                     Physician Order <span style={{ color: "#FF000F" }}>*</span>
//                                 </label>

//                                 <div className="flex justify-between items-center mt-1">
//                                     <div>
//                                         {ConsentFour && (
//                                             <div className="flex items-center gap-1">
//                                                 <EyeOutlined
//                                                     className="cursor-pointer px-1 text-lg"
//                                                     onClick={() => showPdf("PHYSICIAN_ORDER")}
//                                                 />
//                                                 <img
//                                                     className="cursor-pointer w-4 h-4"
//                                                     onClick={() => handleDelete("PHYSICIAN_ORDER")}
//                                                     src={deleteHoverIcon}
//                                                     alt="delete"
//                                                 />
//                                             </div>
//                                         )}
//                                     </div>

//                                     <label className="cursor-pointer viewbtn">
//                                         <input
//                                             type="file"
//                                             onChange={(e) =>
//                                                 changeHandler(e.target.files[0], "PHYSICIAN_ORDER")
//                                             }
//                                             className="hidden"
//                                         />
//                                         <span className="rounded-sm text-lg bg-brand-primaryColor">
//                                             <UploadOutlined className="text-white p-4 font-bold" />
//                                         </span>
//                                     </label>
//                                 </div>
//                             </div>

//                             <div className="my-3 items-center bg-[#F4FEFF] rounded-md p-2 border">
//                                 <label>
//                                     On Device Responsibility{" "}
//                                     <span style={{ color: "#FF000F" }}>*</span>
//                                 </label>

//                                 <div className="flex justify-between items-center mt-1">
//                                     <div>
//                                         {consentThree && (
//                                             <div className="flex items-center gap-1">
//                                                 <EyeOutlined
//                                                     className="cursor-pointer px-1 text-lg"
//                                                     onClick={() => showPdf("DEVICE_RESP")}
//                                                 />
//                                                 <img
//                                                     className="cursor-pointer w-4 h-4"
//                                                     onClick={() => handleDelete("DEVICE_RESP")}
//                                                     src={deleteHoverIcon}
//                                                     alt="delete"
//                                                 />
//                                             </div>
//                                         )}
//                                     </div>

//                                     <label className="cursor-pointer viewbtn">
//                                         <input
//                                             type="file"
//                                             accept="application/pdf"
//                                             onChange={(e) =>
//                                                 changeHandler(e.target.files[0], "DEVICE_RESP")
//                                             }
//                                             className="hidden"
//                                         />
//                                         <span className="rounded-sm text-lg bg-brand-primaryColor">
//                                             <UploadOutlined className="text-white p-4 font-bold" />
//                                         </span>
//                                     </label>
//                                 </div>
//                             </div>

//                             {/* To Share Patient Data */}
//                             <div className="my-3 items-center bg-[#F4FEFF] rounded-md p-2 border">
//                                 <label>
//                                     To Share Patient Data{" "}
//                                     <span style={{ color: "#FF000F" }}>*</span>
//                                 </label>

//                                 <div className="flex justify-between items-center mt-1">
//                                     <div>
//                                         {consentTwo && (
//                                             <div className="flex items-center gap-1">
//                                                 <EyeOutlined
//                                                     className="cursor-pointer px-1 text-lg"
//                                                     onClick={() => showPdf("PATIENT_DATA")}
//                                                 />
//                                                 <img
//                                                     className="cursor-pointer w-4 h-4"
//                                                     onClick={() => handleDelete("PATIENT_DATA")}
//                                                     src={deleteHoverIcon}
//                                                     alt="delete"
//                                                 />
//                                             </div>
//                                         )}
//                                     </div>

//                                     <label className="cursor-pointer viewbtn">
//                                         <input
//                                             type="file"
//                                             accept="application/pdf"
//                                             onChange={(e) =>
//                                                 changeHandler(e.target.files[0], "PATIENT_DATA")
//                                             }
//                                             className="hidden"
//                                         />
//                                         <span className="rounded-sm text-lg bg-brand-primaryColor">
//                                             <UploadOutlined className="text-white p-4 font-bold" />
//                                         </span>
//                                     </label>
//                                 </div>
//                             </div>

//                             {/* On Program */}
//                             <div className="my-3 items-center bg-[#F4FEFF] rounded-md p-2 border">
//                                 <label>
//                                     On Program <span style={{ color: "#FF000F" }}>*</span>
//                                 </label>

//                                 <div className="flex justify-between items-center mt-1">
//                                     <div>
//                                         {consentOne && (
//                                             <div className="flex items-center gap-1">
//                                                 <EyeOutlined
//                                                     className="cursor-pointer px-1 text-lg"
//                                                     onClick={() => showPdf("PROGRAM")}
//                                                 />
//                                                 <img
//                                                     className="cursor-pointer w-4 h-4"
//                                                     onClick={() => handleDelete("PROGRAM")}
//                                                     src={deleteHoverIcon}
//                                                     alt="delete"
//                                                 />
//                                             </div>
//                                         )}
//                                     </div>

//                                     <label className="cursor-pointer viewbtn">
//                                         <input
//                                             type="file"
//                                             accept="application/pdf"
//                                             onChange={(e) =>
//                                                 changeHandler(e.target.files[0], "PROGRAM")
//                                             }
//                                             className="hidden"
//                                         />
//                                         <span className="rounded-sm text-lg bg-brand-primaryColor">
//                                             <UploadOutlined className="text-white p-4 font-bold" />
//                                         </span>
//                                     </label>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </AddInsuranceDetails>
//             </div>

//             <Modal
//                 title={
//                     <span className="font-bold text-base">Add Chronic Condition</span>
//                 }
//                 open={isModalOpen}
//                 onCancel={handleModalClose}
//                 footer={[]}
//                 destroyOnClose
//             >
//                 <AddChronicCondition
//                     handleModalClose={handleModalClose}
//                     handlSetLocalMappedChronics={handlSetLocalMappedChronics}
//                 />
//             </Modal>

//             <Modal
//                 title="View"
//                 open={pdfVisible}
//                 centered={true}
//                 footer={[]}
//                 onCancel={handlePdfViewClose}
//                 width={600}
//                 destroyOnClose
//             >
//                 <embed
//                     src={viewDoc}
//                     width="100%"
//                     type="application/pdf"
//                     height="500px"
//                 />
//             </Modal>
//         </div>
//     );
// }

// export default ProgramInsurance

import { Flex, message, Modal, Spin } from 'antd'
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { CiCirclePlus } from 'react-icons/ci';
import { encodeBase64File } from '../../../../../utils/encodeBase64';
import { EyeOutlined, UploadOutlined } from "@ant-design/icons";
import AddInsuranceDetails from './addInsuranceDetails';
import ProgInsuranceCCTable from './progInsuranceCCTable';
import nodatafound from "../../../../../Assets/Images/Svg/nodatafound.svg";
import AddChronicCondition from './addNewRpmChronic';
import { useDispatch, useSelector } from 'react-redux';
import { convertUTCDate } from '../../../../../utils/convertionFunc';
import { handleSetPatientRegistrationPayload } from '../../../../../Redux/actions/patientActions';
import deleteHoverIcon from "../../../../../Assets/Images/hoverdelete.svg";

function ProgramInsurance({ currPageView, handleCancel, handleNext, handlePrevious, isRpmEnabled }, ref) {
    const [consentOne,   setConsentOne]   = useState(null);
    const [consentTwo,   setConsentTwo]   = useState(null);
    const [consentThree, setConsentThree] = useState(null);
    const [ConsentFour,  setConsentFour]  = useState(null);
    const [viewDoc,      setViewDoc]      = useState("");
    const [pdfVisible,   setPdfVisible]   = useState(false);
    const [isLoading,    setIsLoading]    = useState(false);
    const [isModalOpen,  setIsModalOpen]  = useState(false);
    const [currLocalMappedChronics, setCurrLocalMappedChronics] = useState([]);

    const { registrationPayload, selectedEditPatient } = useSelector((s) => s.patients);
    const dispatch  = useDispatch();
    const loggedUserObj = sessionStorage.getItem('login_result');
    const loggedUser    = loggedUserObj ? JSON.parse(loggedUserObj) : null;

    // ── Expose collectValues ──────────────────────────────────────────────────
    // Consent files are already dispatched to Redux in changeHandler on upload.
    // Chronics are local state — sync them here.

    useImperativeHandle(ref, () => ({
        collectValues: () => {
            if (!currLocalMappedChronics.length) return;
            const payload = {
                ...registrationPayload,
                patientChronicConditionsList: currLocalMappedChronics,
            };
            dispatch(handleSetPatientRegistrationPayload(payload));
        }
    }));

    // ── Effects (unchanged) ───────────────────────────────────────────────────

    useEffect(() => {
        if (selectedEditPatient?.patientChronicConditionsList) {
            setCurrLocalMappedChronics(selectedEditPatient.patientChronicConditionsList);
        }
        if (selectedEditPatient?.patientRegConsentDtlList?.length > 0) {
            selectedEditPatient.patientRegConsentDtlList.forEach(({ consentCode, esignName }) => {
                if (!esignName) return;
                const url = process.env.REACT_APP_IMAGE_URL + esignName;
                if (consentCode === 'PROGRAM')          setConsentOne(url);
                if (consentCode === 'PATIENT_DATA')     setConsentTwo(url);
                if (consentCode === 'DEVICE_RESP')      setConsentThree(url);
                if (consentCode === 'PHYSICIAN_ORDER')  setConsentFour(url);
            });
        }
    }, [selectedEditPatient]);

    // ── Handlers (unchanged) ─────────────────────────────────────────────────

    const changeHandler = async (file, e) => {
        if (file.type !== "application/pdf") { message.error("Please upload only PDF files"); return; }
        if (file.size > 10 * 1024 * 1024)   { message.error("Pdf size should be ≤ 10 MB");   return; }

        const base64Encoded = await encodeBase64File(file);
        const payload = {
            account_Id: loggedUser?.user?.account_Id,
            clinic_Id:  loggedUser?.user?.clinic_Id,
            consentCode: e, consentName: "",
            createdBy: loggedUser?.user?.userId, createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
            esign: base64Encoded, esignType: file.type.split('/')[1],
            modifiedBy: loggedUser?.user?.userId, modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
            otpConsent: "Y", status: 1,
        };
        if (selectedEditPatient) payload.patientId = selectedEditPatient.patientId;

        const nameMap = { PROGRAM: "OnProgram", PATIENT_DATA: "ToSharePatientData", DEVICE_RESP: "OnDeviceResponsibility", PHYSICIAN_ORDER: "Physician Order" };
        payload.consentName = nameMap[e] || "";
        if (e === 'PROGRAM')          setConsentOne(file);
        if (e === 'PATIENT_DATA')     setConsentTwo(file);
        if (e === 'DEVICE_RESP')      setConsentThree(file);
        if (e === 'PHYSICIAN_ORDER')  setConsentFour(file);

        const updated = [...(registrationPayload?.patientRegConsentDtlList || [])].filter((i) => i.consentCode !== e);
        updated.push(payload);
        dispatch(handleSetPatientRegistrationPayload({ ...registrationPayload, patientRegConsentDtlList: updated }));
    };

    const showPdf = (e) => {
        const file = e === 'PROGRAM' ? consentOne : e === 'PATIENT_DATA' ? consentTwo : e === 'DEVICE_RESP' ? consentThree : ConsentFour;
        if (!file) return;
        if (typeof file === 'string' && file.toLowerCase().endsWith('.pdf')) { setViewDoc(file); setPdfVisible(true); }
        else if (file instanceof File && file.type === 'application/pdf')    { setViewDoc(URL.createObjectURL(file)); setPdfVisible(true); }
    };

    const handleDelete = (e) => {
        if (e === 'PROGRAM')         setConsentOne(null);
        if (e === 'PATIENT_DATA')    setConsentTwo(null);
        if (e === 'DEVICE_RESP')     setConsentThree(null);
        if (e === 'PHYSICIAN_ORDER') setConsentFour(null);
        const updated = (registrationPayload?.patientRegConsentDtlList || []).filter((i) => i.consentCode !== e);
        dispatch(handleSetPatientRegistrationPayload({ ...registrationPayload, patientRegConsentDtlList: updated }));
    };

    const handlSetLocalMappedChronics = (obj) => setCurrLocalMappedChronics((p) => [...p, obj]);

    const CONSENTS = [
        { code: 'PHYSICIAN_ORDER', label: 'Physician Order',       state: ConsentFour  },
        { code: 'DEVICE_RESP',     label: 'On Device Responsibility', state: consentThree },
        { code: 'PATIENT_DATA',    label: 'To Share Patient Data',  state: consentTwo   },
        { code: 'PROGRAM',         label: 'On Program',             state: consentOne   },
    ];

    return (
        <div>
            <div className="w-full">
                <div className="flex justify-between space-x-4 m-2 mb-5">
                    <h3 className="font-bold text-base">Chronic Conditions</h3>
                    <button onClick={() => setIsModalOpen(true)} disabled={!isRpmEnabled} className="w-28 h-9 px-2 flex bg-[#F1FFF9] items-center gap-2 border border-[#3B98B9] rounded-md disabled:opacity-50 disabled:cursor-not-allowed">
                        <CiCirclePlus className="w-5 h-5 text-[#189FAA]" /><span>Add New</span>
                    </button>
                </div>
            </div>

            <div className={`${!isLoading && currLocalMappedChronics?.length === 0 ? "w-full flex justify-center items-center" : "overflow-y-scroll scrollWidth"}`}>
                {isLoading && currLocalMappedChronics?.length === 0 ? (
                    <div className="flex items-center justify-center mt-[10%]"><Flex align="center" gap="middle"><Spin size="large" tip="Loading" /></Flex></div>
                ) : currLocalMappedChronics?.length === 0 ? (
                    <div className="flex flex-col items-center justify-center"><img src={nodatafound} alt="nodatafound" className="h-min w-min" /><p className="font-medium text-xl">No data found!!</p></div>
                ) : (
                    <ProgInsuranceCCTable data={currLocalMappedChronics} totalCount={currLocalMappedChronics?.length} />
                )}
            </div>

            <div>
                <AddInsuranceDetails currPageView={currPageView} handleCancel={handleCancel} handleNext={handleNext} handlePrevious={handlePrevious} currLocalMappedChronics={currLocalMappedChronics} isRpmEnabled={isRpmEnabled}>
                    <div>
                        <h3 className="font-bold text-base my-3">Consent Form</h3>
                        <h4 className="font-bold text-base my-3">Attachment Details</h4>
                        <div>File Supported: <span className="text-blue-500">PDF - Up to 10MB</span></div>
                        <div className="grid md:grid-cols-4 grid-cols-2 gap-1">
                            {CONSENTS.map(({ code, label, state }) => (
                                <div key={code} className="my-3 items-center bg-[#F4FEFF] rounded-md p-2 border">
                                    <label>{label} <span style={{ color: "#FF000F" }}>*</span></label>
                                    <div className="flex justify-between items-center mt-1">
                                        {state && (
                                            <div className="flex items-center gap-1">
                                                <EyeOutlined className="cursor-pointer px-1 text-lg" onClick={() => showPdf(code)} />
                                                <img className="cursor-pointer w-4 h-4" onClick={() => handleDelete(code)} src={deleteHoverIcon} alt="delete" />
                                            </div>
                                        )}
                                        <label className="cursor-pointer viewbtn">
                                            <input type="file" accept="application/pdf" disabled={!isRpmEnabled} onChange={(e) => changeHandler(e.target.files[0], code)} className="hidden" />
                                            <span className="rounded-sm text-lg bg-brand-primaryColor"><UploadOutlined className="text-white p-4 font-bold" /></span>
                                        </label>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </AddInsuranceDetails>
            </div>

            <Modal title={<span className="font-bold text-base">Add Chronic Condition</span>} open={isModalOpen} onCancel={() => setIsModalOpen(false)} footer={[]} destroyOnClose>
                <AddChronicCondition handleModalClose={() => setIsModalOpen(false)} handlSetLocalMappedChronics={handlSetLocalMappedChronics} />
            </Modal>
            <Modal title="View" open={pdfVisible} centered footer={[]} onCancel={() => setPdfVisible(false)} width={600} destroyOnClose>
                <embed src={viewDoc} width="100%" type="application/pdf" height="500px" />
            </Modal>
        </div>
    );
}

export default forwardRef(ProgramInsurance);